export default "__VITE_ASSET__BAa6_wQo__"